function datetimeFormat(data) {
    if (!data) return "";

    let date = new Date(data);
    let formated = "";

    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    let hour = date.getHours();
    let minutes = date.getMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;

    formated = `${day}/${month}/${year} (${hour}:${minutes})`;
    return formated;
}
module.exports = datetimeFormat;
